module.exports = __webpack_public_path__ + "static/media/moraine-25.65bb1539.jpg";